import React from "react";
import { useSessionContext } from "../components/Session";
import { Link } from "../components/Router";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../sass/footer.scss";
import { CODEBUILD_BUILD_NUMBER, CODEBUILD_GIT_SHORT_ID } from "api-config";

const AdminDebugInfo = () => {
  return (
    <>
      <p className="copy-right-text pt-4">
        Build: {CODEBUILD_BUILD_NUMBER} Commit: {CODEBUILD_GIT_SHORT_ID}
      </p>
    </>
  );
};

const Footer = () => {
  const { sessionContext } = useSessionContext();
  const { isAdminUser } = sessionContext;

  return (
    <>
      <footer className="main-footer d-md-block d-none">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="list-group bottom-nav">
                <div className="list-group-item">
                  <Link to="/calendar">Earnings Calendar</Link>
                </div>
                <div className="list-group-item">
                  <Link to="/about">About</Link>
                </div>
                <div className="list-group-item">
                  <Link to="/terms">Terms of Use</Link>
                </div>
                <div className="list-group-item">
                  <Link to="/privacy">Privacy Policy</Link>
                </div>
              </div>
            </Col>
          </Row>
          <p className="copy-right-text">
            &copy;Earnings Call, LLC {new Date().getFullYear()}
          </p>
          {isAdminUser && <AdminDebugInfo />}
        </Container>
      </footer>
    </>
  );
};

export default Footer;
